export default __webpack_public_path__ + "static/media/traffic.3af00677.png";